<template>
  <div class="filters-sidebar formikation">
    <Dropdown  :title="$t('commons.filter_destination_title')"
               :subtitle="`${$t('commons.categories')}, ${$t('commons.continent')}, ${$t('shared.fastbooking.home.countries')}`"
               :contentData="{
                  filters: this.filters,
                  selectedFilters: this.selectedFilters,
               }"
               :initialIsOpen="true"
      >
      <template v-slot:content="isOpen">
        <template v-if="isOpen.isOpen">
          <div :key="0" class="filters filters-vue">
            <p class="t-label">{{$t('commons.category')}}</p>
            <label :for="`nst-${filter.id}`"
                  class="with-counter fk-check init"
                  :class="{ disabled: filter.disabled, checked: filter.checked}"
                  v-for="(filter, key) in filters.nst"
                  :key="`nst-${key}`"
            >
              <input type="checkbox"
                    name="is-club"
                    :id="`nst-${filter.id}`"
                    class="init"
                    data-utag-click= '{"event_name":" filters", "event_cat":"filters destinations","event_act":"the club","event_lbl":"the club", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body">
}'
                    :value="filter.id"
                    :checked="filter.checked"
                    @change="$emit('filter-checked-checkbox', {name:'nst', value: parseInt($event.target.value), event: $event})"
              />
              {{filter.label[$locale]}}
            </label>
          </div>
          <div :key="1" class="filters filters-vue">
            <p class="t-label">{{$t('commons.continent_and_country')}}</p>
            <label :for="`continent-${filter.id}`"
                  class="with-counter fk-check init"
                  :class="{ disabled: filter.disabled, checked: filter.checked}"
                  v-for="(filter, key) in filters.zones"
                  :key="`continent-${key}`"
            >
              <input type="checkbox"
                    name="continents"
                    :id="`continent-${filter.id}`"
                    class="init"
                    :value="filter.id"
                    :data-utag-click= '`{"event_name":" filters", "event_cat":"filters destinations", "event_act":"continents", "event_lbl": "${filter.label.en.toLowerCase()}", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body" }`'
                    :checked="filter.checked"
                    @change="$emit('filter-checked-checkbox', {name:'zones', value: parseInt($event.target.value), event: $event})"
              />
              {{filter.label[$locale]}}
            </label>
            <label class="select-all fk-check"
                  for="zones_all"
                  :class="{checked : selectedFilters.all_zones}"
            >
                <input type="checkbox" name="zones"
                  id="zones_all"
                  value="all_zones"
                  class="init"
                  @change="$emit('filter-checked-all', {name:'zones', value: parseInt($event.target.value), event: $event})"
                >
                {{$t('commons.select_all')}}
            </label>
          </div>
          <div :key="2" class="filters filters-vue">
            <p class="t-label">{{$t('commons.country')}}</p>
            <label :for="`country-${filter.id}`"
                  :class="`with-counter fk-check init ${filter.disabled ? 'disabled' : ''} ${filter.checked ? 'checked' : ''} ${selectedFilters.zones.length > 0 ? selectedFilters.zones.includes(filter.zone) ? '' : 'hidden' : ''}`"
                  v-for="(filter, key) in filters.countries"
                  :key="`country-${key}`"
            >
              <input type="checkbox"
                    name="countries"
                    :id="`country-${filter.id}`"
                    class="init"
                    :data-utag-click= '`{"event_name":" filters", "event_cat":"filters destinations", "event_act":"countries", "event_lbl": "${filter.label.en.toLowerCase()}", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body" }`'
                    :data-act-utag-filter='`countries`'
                    :value="filter.id"
                    :checked="filter.checked"
                      @change="$emit('filter-checked-checkbox', {name:'countries', value: parseInt($event.target.value), event: $event})"
              />
              {{filter.label[$locale]}}
              <span class="hotel-count" >({{filter.hotels}} {{`${filter.hotels > 1 || filter.hotels == 0 ? $t('commons.hotels')  : $t('commons.hotel')}`}})</span>
            </label>
            <label class="select-all fk-check"
                  for="countries_all"
                  :class="{checked : selectedFilters.all_countries}"
            >
                <input type="checkbox" name="countries"
                  id="countries_all"
                  value="all_countries"
                  class="init"
                  @change="$emit('filter-checked-all', {name:'countries', event: $event, parent_id: selectedFilters.zones })"
                >
                {{$t('commons.select_all')}}
            </label>
          </div>
        </template>
      </template>
    </Dropdown>
    <Dropdown :title="$t('commons.filter_services_title')"
              :subtitle="`${$t('bookings.filter_categories.stars')}, ${$t('bookings.filter_features.feature')}`"
              :contentData="{
                  filters: this.filters
               }"
      >
      <template v-slot:content="isOpen">
        <template v-if="isOpen.isOpen">
          <div :key="0" class="filters filters-vue">
            <p class="t-label">{{$t('bookings.filter_categories.stars')}}</p>
            <label :for="`categories-${filter.id}`"
                  class="with-counter fk-check init"
                  :class="{checked: filter.checked, disabled: filter.disabled}"
                  v-for="(filter, key) in filters.categories"
                  :key="`categories-${key}`"
            >
              <input type="checkbox"
                    name="categories"
                    :id="`categories-${filter.id}`"
                    class=""
                    :data-utag-click= '`{"event_name":" filters", "event_cat":"filters destinations", "event_act":"stars", "event_lbl": "${filter.label.utag}", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body" }`'
                    :data-act-utag-filter="`stars`"
                    :value="filter.id"
                    :checked="filter.checked"
                    @change="$emit('filter-checked-checkbox', {name:'categories', value: $event.target.value, event: $event})"
              />
              <span :class="`rating-stars r${filter.label[$locale]}`"></span>
              <span class="hotel-count" >
                <span class="hotel-count" >({{filter.hotels}} {{`${filter.hotels > 1 || filter.hotels == 0 ? $t('commons.hotels') : $t('commons.hotel')}`}})</span>
              </span>
            </label>
          </div>
          <div :key="1" class="filters filters-vue">
            <p class="t-label">{{ $t('commons.filter_services_title') }}</p>
            <label :for="`features-${filter.id}`"
                  class="with-counter fk-check init"
                  :class="{ disabled: filter.disabled, checked: filter.checked}"
                  v-for="(filter, key) in filters.features"
                  :key="`features-${key}`"
            >
              <input type="checkbox"
                    name="feature"
                    :id="`features-${filter.id}`"
                    :data-utag-click= '`{"event_name":" filters", "event_cat":"filters destinations", "event_act":"services", "event_lbl": "${filter.label.en.toLowerCase()}", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body" }`'
                    :data-act-utag-filter="`services`"
                    :value="filter.id"
                    :checked="filter.checked"
                    @change="$emit('filter-checked-checkbox', {name:'features', value: parseInt($event.target.value), event: $event})"
              />
              {{filter.label[$locale]}}
              <span class="hotel-count" >({{filter.hotels}} {{`${filter.hotels > 1 || filter.hotels == 0 ? $t('commons.hotels')  : $t('commons.hotel')}`}})</span>
            </label>
          </div>
        </template>
      </template>
    </Dropdown>
    <Dropdown :title="$t('commons.filter_specialties_title')"
              :subtitle="`${$t('commons.experiences')}, ${$t('commons.activities')}`"
              :contentData="{
                filters: this.filters
              }"
      >
      <template v-slot:content="isOpen">
        <template v-if="isOpen.isOpen">
          <div :key="0" class="filters filters-vue">
            <p class="t-label">{{ $t('commons.filter_specialties_title') }}</p>
            <label :for="`specialties-${filter.id}`"
                  class="with-counter fk-check init"
                  :class="{ disabled: filter.disabled, checked: filter.checked}"
                  v-for="(filter, key) in filters.specialties"
                  :key="`specialties-${key}`"
            >
              <input type="checkbox"
                    name="specialties"
                    :id="`specialties-${filter.id}`"
                    :data-utag-click= '`{"event_name":" filters", "event_cat":"filters destinations", "event_act":"specialities", "event_lbl": "${filter.label.en.toLowerCase()}", "only_checked": "true", "event_purpose": "inspiration", "event_structure": "body" }`'
                    :value="filter.id"
                    :data-act-utag-filter="`specialties`"
                    :checked="filter.checked"
                    @change="$emit('filter-checked-checkbox', {name:'specialties', value: parseInt($event.target.value), event: $event})"
              />
              {{filter.label[$locale]}}
              <span class="hotel-count" >({{filter.hotels}} {{`${filter.hotels > 1 || filter.hotels == 0 ? $t('commons.hotels')  : $t('commons.hotel')}`}})</span>
            </label>
          </div>
        </template>
      </template>
    </Dropdown>
    <div class="bottom-actions-in-app show-in-app"
        :class="`${displayButtonFilters ? 'mobile-buttons-app' : ''} `">
      <a class="clear-all filters-app-button" href="#fb-results" @click.prevent="$emit('resetFilters')">
        <span>
          {{$t('commons.clear_filters')}}
        </span>
      </a>
      <a class="apply-filters filters-app-button mobile-only" @click.prevent="$emit('toggleFilters')">
        {{$t('commons.apply_filters')}}
        </a>
      <a class="close-filters filters-app-button mobile-only" @click.prevent="$emit('toggleFilters')">
        {{$t('commons.close_filters')}}
        </a>
    </div>
    <div class="bottom-actions mobile-only hide-in-app"
        :class="`${displayButtonFilters ? 'mobile-buttons' : ''}`">
      <a class="clear-all" href="#fb-results" @click.prevent="$emit('resetFilters')">
        <span>
          {{$t('commons.clear_filters')}}
        </span>
      </a>
      <a class="apply-filters" @click.prevent="$emit('toggleFilters')">
        {{$t('commons.apply_filters')}}
        </a>
    </div>
  </div>
</template>

<script>
import Dropdown from './Dropdown';

export default {
  name: 'FiltersSidebar',
  props: {
    filters: Object,
    selectedFilters: Object,
    displayButtonFilters: Boolean
  },
  components: {
    Dropdown
  },
  methods: {
  }
}
</script>
